<form (ngSubmit)="onSubmit(inviteForm.getFormData())" snDrawer>
  <sn-drawer-header [title]="'common.share' | t">
    <sn-icon-button icon="close" snDrawerClose snDrawerNavButton></sn-icon-button>
    <sn-drawer-header-actions>
      <sn-flat-button color="success" type="submit" [disabled]="form.invalid">{{ 'common.send' | t }}</sn-flat-button>
    </sn-drawer-header-actions>
  </sn-drawer-header>

  <sn-drawer-content indented>
    <sn-share-invite-form
      #inviteForm
      [form]="form"
      [formModel]="formModel"
      [additionalFields]="additionalFields"
    >
    </sn-share-invite-form>
  </sn-drawer-content>
</form>
